import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';
import { Oferta, Promocion } from '../services/ofertas-service/models/ofertas';

interface OfertaCardContextType {
	hasOneCarline: boolean;
	isCallMeNowOpen: boolean;

	// Estados internos que antes se manejaban por prop drilling
	isLayerVisible: boolean;
	setIsLayerVisible: Dispatch<SetStateAction<boolean>>;

	selectedOferta?: Oferta;
	setSelectedOferta: Dispatch<SetStateAction<Oferta | undefined>>;

	setSelectedPromotion: Dispatch<SetStateAction<Promocion | undefined>>;
	selectedPromotion: Promocion | undefined;

	handleLayerOnClick: () => void;

	handleScrollToDisclaimer: (reference: string) => void;
}

const OfertaCardContext = createContext<OfertaCardContextType | undefined>(undefined);

export const OfertaCardProvider = ({ children, value }: { children: ReactNode; value: OfertaCardContextType }) => {
	return <OfertaCardContext.Provider value={value}>{children}</OfertaCardContext.Provider>;
};

export const useOfertaCard = () => {
	const context = useContext(OfertaCardContext);
	if (!context) throw new Error('useOfertaCard debe usarse dentro de OfertaCardProvider');
	return context;
};
